import { Button } from "@/components/Button/Button";
import { EmptyState } from "@/components/EmptyState/EmptyState";
import { Beacon } from "@/utils/beacon";
import { ensureError, localizeError } from "@/utils/helpers";
import { useTranslation } from "react-i18next";

export interface DisplayErrorProps {
  error: unknown;
}

/**
 * Display an Error
 *
 * This component delegates its layout to {@link EmptyState}
 *
 * The title is extracted and translated from the error itself via {@link ensureError} and {@link localizeError}
 *
 * A generic error illustration, a translated message, and a button are supplied
 *
 * The button launches the Jira Service Management support widget.
 */
export const DisplayError = ({ error }: DisplayErrorProps) => {
  const { t } = useTranslation();
  const title = localizeError(t, ensureError(error));

  return (
    <EmptyState
      title={title}
      image={<img src={"/images/not-found.svg"} />}
      message={t("common:displayError.message")}
      button={
        <Button
          color="primary"
          variant="contained"
          onClick={() => Beacon("open")}
          sx={{
            mt: "1.5em"
          }}
        >
          {t("common:displayError.button")}
        </Button>
      }
    />
  );
};
